import {BrowserModule} from '@angular/platform-browser';
import {NgModule} from '@angular/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {HTTP_INTERCEPTORS, HttpClientModule} from '@angular/common/http';
import {DndModule} from 'ng2-dnd';

import {AppComponent} from './app.component';
import {QuestionnaireService} from './service/questionnaire.service';
import {MessageService} from './service/message.service';
import {MessageComponent} from './message/message.component';
import {AnswerService} from './service/answer.service';
import {AppRoutingModule} from './app-routing.module';
import {QuestionnairesComponent} from './questionnaires/questionnaires.component';
import {TracksComponent} from './tracks/tracks.component';
import {ContentService} from './service/content.service';
import {UploadFileComponent} from './upload-file/upload-file.component';
import {NavigationComponent} from './navigation/navigation.component';
import {TrackService} from './service/track.service';
import {ArticlesComponent} from "./articles/articles.component";
import {ArticleComponent} from "./article/article.component";
import {ArticleService} from "./service/article.service";
import {UsersComponent} from './users/users.component';
import {UserService} from "./service/user.service";
import {RecommendationService} from './service/recommendation.service';
import {PlaylistComponent} from './playlist/playlist.component';
import {PlaylistsComponent} from './playlists/playlists.component';
import {PlaylistService} from './service/playlist.service';
import {QuestionnaireReportComponent} from './questionnaire-report/questionnaire-report.component';
import {CropPipe, DurationPipe} from './constants';
import {TrackEditComponent} from './track-edit/track-edit.component';
import {QuestionnaireEditComponent} from './questionnaire-edit/questionnaire-edit.component';
import {ModalModule, ProgressbarModule} from "ngx-bootstrap";
import {ModalDeactivationGuard} from "./modal-deactivation.guard";
import {RecommendationEditWizardComponent} from './recommendation-edit-wizard/recommendation-edit-wizard.component';

import 'rxjs/add/operator/map';
import 'rxjs/add/operator/mergeMap';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/finally';
import {NgxSpinnerModule} from "ngx-spinner";
import {LoaderService} from "./service/loader.service";
import {HttpLoaderInterceptorService} from "./service/http-loader-interceptor.service";

@NgModule({
  declarations: [
    AppComponent,
    MessageComponent,
    QuestionnairesComponent,
    TracksComponent,
    UploadFileComponent,
    NavigationComponent,
    TracksComponent,
    ArticlesComponent,
    ArticleComponent,
    UsersComponent,
    PlaylistComponent,
    PlaylistsComponent,
    UsersComponent,
    QuestionnaireReportComponent,
    CropPipe,
    DurationPipe,
    TrackEditComponent,
    QuestionnaireEditComponent,
    RecommendationEditWizardComponent
  ],
  imports: [
    BrowserModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    DndModule.forRoot(),
    ModalModule.forRoot(),
    ProgressbarModule.forRoot(),
    NgxSpinnerModule,
    AppRoutingModule
  ],
  providers: [QuestionnaireService,
    MessageService,
    AnswerService,
    ContentService,
    TrackService,
    ArticleService,
    UserService,
    RecommendationService,
    PlaylistService,
    LoaderService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpLoaderInterceptorService,
      multi: true
    },
    ModalDeactivationGuard
  ],
  entryComponents: [
    RecommendationEditWizardComponent
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
}



// WEBPACK FOOTER //
// /home/developer/Downloads/SleepRestoreBackend/sleep-restore-boot/src/main/ngapp/src/app/app.module.ts